import { useUser } from "@/api/hooks/user";
import { OpenFeature } from "@openfeature/react-sdk";
import { useEffect, useState } from "react";

export type FeatureFlagContextState = {
  userKey: string | null;
  contextReady: boolean;
};

export const useInitFeatureFlagContext = (sessionActivated: boolean): FeatureFlagContextState => {
  const { user } = useUser(sessionActivated);
  const [contextReady, setContextReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!user) {
      setContextReady(false);
      return () => {
        cancelled = true;
      };
    }

    setContextReady(false);
    void OpenFeature.setContext({ userKey: user.username })
      .then(() => {
        if (!cancelled) {
          setContextReady(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setContextReady(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return { userKey: user?.username ?? null, contextReady };
};
